/**
 * **Space で再生 / 一時停止**（`/duel-timing` と `/duel-editor`）。
 *
 * - 文字を打つ欄（テキストの input・textarea・select・contenteditable）の中では奪わない
 * - ボタン・チェックボックスにフォーカスが残っていても奪う（既定の動作を止めてフォーカスを外す）——
 *   止めないと、直前に押したボタンを Space がもう一度押してしまう（入力画面の pcKeys と同じ理由）
 * - 押しっぱなし（repeat）と修飾キー付きは無視
 */
import { useEffect, useRef } from 'react';

const TEXT_INPUTS = new Set(['text', 'search', 'email', 'url', 'tel', 'password', 'number', 'date', 'time', 'datetime-local', 'month', 'week']);

/** その要素で Space を奪ってよいか（文字を打つ欄なら false） */
export function spaceTakesOver(target) {
  if (!target || typeof target !== 'object') return true;
  if (target.isContentEditable) return false;
  const tag = String(target.tagName ?? '').toLowerCase();
  if (tag === 'textarea' || tag === 'select') return false;
  if (tag === 'input') return !TEXT_INPUTS.has(String(target.type ?? 'text').toLowerCase());
  return true;
}

export function useSpaceKey(onToggle, enabled = true) {
  const ref = useRef(onToggle);
  ref.current = onToggle;
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined;
    const onKey = (e) => {
      if (e.code !== 'Space' && e.key !== ' ') return;
      if (e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
      if (!spaceTakesOver(e.target)) return;
      e.preventDefault();
      if (typeof document !== 'undefined' && document.activeElement && document.activeElement !== document.body) document.activeElement.blur?.();
      ref.current?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);
}
